"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-undef */
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const bit_unifiedcomponents_stopper_1 = __importDefault(require("@gcloud-npm/bit.unifiedcomponents.stopper"));
const bit_utils_front_sonda_1 = __importDefault(require("@gcloud-npm/bit.utils.front-sonda"));
const Error_1 = __importDefault(require("./Screens/Error"));
/**
 * Componente statefull que crea el ErrorBoundary
 * @param {string} error Error atrapado
 * @param {string} errorInfo Detalles del error que renderiza la pagina
 * @returns {JSX} Componente JSX.
 */
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        /**
         * Crea una subscripcion para escuchar los cambios del history
         */
        this.componentDidMount = () => {
            const { history } = this.props;
            history.listen((location) => {
                const { errorInfo } = this.state;
                if (errorInfo) {
                    this.setState({ redirect: location });
                }
            });
        };
        /**
         * Elimina la subscripcion del history al desmontarse el componente
         */
        this.componentWillUnmount = () => {
            const { history } = this.props;
            if (history) {
                try {
                    history.removeEventListener('listen');
                }
                catch (err) {
                    // console.log(`err: ${err}`);
                }
            }
        };
        /**
         * Crea y envia el sondado con el error capturado
         * @param {error} error Error producion
         * @return {undefined}
         */
        this.sendSondaInfo = (error) => {
            const { contextData } = this.state;
            const sonda = new bit_utils_front_sonda_1.default({
                processName: 'ErrorBoundary',
                context: contextData,
                filePath: 'AppController',
            });
            sonda.fatalMessage({ error });
        };
        /**
         * Enviar el error que atrapa el errorBoundary
         * @param {error} error Error atrapado
         * @return {undefined}
         */
        this.componentDidCatch = (error) => {
            this.setState({ errorInfo: error });
            this.sendSondaInfo(error);
        };
        const { contextData } = props;
        this.state = {
            errorInfo: null,
            redirect: null,
            contextData,
        };
    }
    render() {
        if (this.state.redirect && this.state.errorInfo) {
            this.setState({ redirect: null, errorInfo: null });
            return react_1.default.createElement(react_router_dom_1.Redirect, { to: this.state.redirect });
        }
        if (!this.state.errorInfo) {
            /* Normally, just render children, all APP */
            return this.props.children;
        }
        const { defaultErrorScreen, projectId } = this.props;
        if (defaultErrorScreen) {
            return react_1.default.createElement(bit_unifiedcomponents_stopper_1.default, Object.assign({}, defaultErrorScreen, { projectId: projectId }));
        }
        return react_1.default.createElement(Error_1.default, null);
    }
}
exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map